// Generated by `vp run l10n:bundle` – do not edit. Source of truth:
// messages/<locale>.json, keys listed in
// tooling/scripts/lib/bundled-message-keys.ts.

/** Catalogue key behind each label, for the drift test. */
export const LABEL_SOURCE_KEYS = {
	announcement_dismiss: "snippet_announcement_dismiss",
	announcement_got_it: "widget_announcement_got_it",
	announcement_kind_business_update: "announcements_kind_business_update",
	announcement_kind_fix: "announcements_kind_fix",
	announcement_kind_improvement: "announcements_kind_improvement",
	announcement_kind_new: "announcements_kind_new",
	announcement_kind_product_update: "announcements_kind_product_update",
	announcement_kind_resource: "announcements_kind_resource",
	announcement_kind_service_status: "announcements_kind_service_status",
	announcement_read: "widget_catch_up_read",
	announcement_view: "snippet_announcement_view",
	close: "snippet_a11y_close",
	onboarding_dismiss: "snippet_onboarding_dismiss",
	onboarding_label: "snippet_onboarding_label",
	open: "snippet_a11y_open",
	preview_confirmation_request: "snippet_preview_confirmation_request",
	preview_later: "snippet_preview_later",
	preview_mark_read: "snippet_preview_mark_read",
	preview_more: "snippet_preview_more_label",
	preview_open_inbox: "snippet_preview_open_inbox",
	preview_replied: "snippet_preview_replied",
	preview_reply: "snippet_preview_reply",
	preview_status_change: "snippet_preview_status_change",
	preview_status_generic: "snippet_preview_status_generic",
	preview_timeframe_change: "snippet_preview_timeframe_change",
	preview_timeframe_change_to: "snippet_preview_timeframe_change_to",
	recording: "snippet_recording_label",
	screenshot_cancel: "snippet_screenshot_cancel",
	screenshot_hint: "snippet_screenshot_hint",
	screenshot_take: "snippet_screenshot_take",
	stop_recording: "snippet_recording_stop",
	title: "snippet_a11y_title",
	tooltip: "snippet_tooltip",
	unread: "snippet_a11y_unread",
} as const;

/** Catalogue key behind each status label, for the drift test. */
export const STATUS_SOURCE_KEYS = {
	archived: "widget_thread_status_archived",
	closed: "widget_thread_status_closed",
	done: "widget_thread_status_done",
	handed_off: "widget_thread_status_handed_off",
	in_progress: "widget_thread_status_in_progress",
	need_review: "widget_thread_status_need_review",
	new: "widget_thread_status_new",
	open: "widget_thread_status_open",
	resolved: "widget_thread_status_resolved",
} as const;

export const MESSAGES = {
	"en": {
		announcement_dismiss: "Dismiss announcement",
		announcement_got_it: "Got it",
		announcement_kind_business_update: "Business update",
		announcement_kind_fix: "Fix",
		announcement_kind_improvement: "Improvement",
		announcement_kind_new: "New",
		announcement_kind_product_update: "Product update",
		announcement_kind_resource: "Resource",
		announcement_kind_service_status: "Service status",
		announcement_read: "Read",
		announcement_view: "View",
		close: "Close feedback widget",
		onboarding_dismiss: "Dismiss",
		onboarding_label: "About this widget",
		open: "Open feedback widget",
		preview_confirmation_request: "Your confirmation is needed – does the fix work?",
		preview_later: "Later",
		preview_mark_read: "Mark read",
		preview_more: "More unread messages in this conversation",
		preview_open_inbox: "Open inbox",
		preview_replied: "{name} replied",
		preview_reply: "New reply",
		preview_status_change: "Status changed to {status}",
		preview_status_generic: "The status of your conversation changed",
		preview_timeframe_change: "The expected timeframe of your conversation changed",
		preview_timeframe_change_to: "Expected timeframe is now {timeframe}",
		recording: "Recording",
		screenshot_cancel: "Cancel",
		screenshot_hint: "Go to the screen to capture",
		screenshot_take: "Screenshot this page",
		stop_recording: "Stop",
		title: "Feedback widget",
		tooltip: "Chat with Weloop AI",
		unread: "Unread conversations: {count}",
	},
	"fr": {
		announcement_dismiss: "Fermer l'annonce",
		announcement_got_it: "Compris",
		announcement_kind_business_update: "Actualité de l'entreprise",
		announcement_kind_fix: "Correctif",
		announcement_kind_improvement: "Amélioration",
		announcement_kind_new: "Nouveau",
		announcement_kind_product_update: "Nouveauté produit",
		announcement_kind_resource: "Ressource",
		announcement_kind_service_status: "État du service",
		announcement_read: "Lire",
		announcement_view: "Voir",
		close: "Fermer le widget de feedback",
		onboarding_dismiss: "Ignorer",
		onboarding_label: "À propos de ce widget",
		open: "Ouvrir le widget de feedback",
		preview_confirmation_request: "Votre confirmation est attendue – le correctif fonctionne-t-il ?",
		preview_later: "Plus tard",
		preview_mark_read: "Marquer comme lu",
		preview_more: "D'autres messages non lus dans cette conversation",
		preview_open_inbox: "Ouvrir la boîte de réception",
		preview_replied: "{name} a répondu",
		preview_reply: "Nouvelle réponse",
		preview_status_change: "Statut changé en {status}",
		preview_status_generic: "Le statut de votre conversation a changé",
		preview_timeframe_change: "Le délai prévu de votre conversation a changé",
		preview_timeframe_change_to: "L’horizon prévu est désormais {timeframe}",
		recording: "Enregistrement",
		screenshot_cancel: "Annuler",
		screenshot_hint: "Affichez l’écran à capturer",
		screenshot_take: "Capturer cette page",
		stop_recording: "Arrêter",
		title: "Widget de feedback",
		tooltip: "Discuter avec Weloop AI",
		unread: "Conversations non lues : {count}",
	},
} as const;

export const STATUS_LABELS = {
	"en": {
		archived: "Archived",
		closed: "Closed",
		done: "Done",
		handed_off: "Handed off",
		in_progress: "In progress",
		need_review: "Needs review",
		new: "New feedback",
		open: "Open",
		resolved: "Resolved",
	},
	"fr": {
		archived: "Archivé",
		closed: "Fermé",
		done: "Terminé",
		handed_off: "Transmis à l'équipe",
		in_progress: "En cours",
		need_review: "À vérifier",
		new: "Nouveau feedback",
		open: "Ouvert",
		resolved: "Résolu",
	},
} as const;
